/**
 * The fight's words on the message line (P2.1-T4; ADR-061's copy rules: sentences in sentence case with a full
 * stop), and the resources' names. Every sentence here is a draft for the author. `unknownAbility` is what the page
 * calls an ability whose number its rules do not hold; `thatAbility` is the same at the end of a sentence.
 */
export const FIGHT = {
  unknownAbility: "That ability",
  thatAbility: "that ability",
  refused: {
    dead: "You cannot fight while you are dead.",
    stunned: "You are stunned.",
    bar: "{ability} is not on your bar.",
    cooldown: "{ability} is not ready yet.",
    cost: "You cannot pay for {ability}.",
    target: "{ability} needs a target.",
    view: "Your target is out of view.",
    range: "Your target is out of range.",
    sight: "Your target is out of sight.",
    peace: "You cannot harm that target here.",
    busy: "You are already acting.",
    passage: "You cannot attack players during your safe passage.",
    targetPassage: "Your target is in safe passage.",
    held: "You cannot act yet.",
    targetHeld: "This player is speaking with a Game Master.",
    other: "{ability} did not work.",
  },
  resources: {
    health: "Health",
    stamina: "Stamina",
    focus: "Focus",
  },
  weakened: "{ability} is weakened.",
  weakenedFor: "Not enough {resource}: {ability} is weakened.",
  death: {
    killerAbility: "{killer} killed you with {ability}.",
    killer: "{killer} killed you.",
    ability: "You were killed with {ability}.",
    none: "You died.",
  },
} as const;
